import React from 'react';

// Renders the 4 seasonal photo slots as a horizontal strip. If a slot has no
// photo, a dimmed placeholder shows the season label. Tap a slot to open it
// (for adding / viewing), handled by the parent via `onSlotClick`.
const SLOTS = [
  { key: 'spring', label: 'Spring', emoji: '🌸' },
  { key: 'summer', label: 'Summer', emoji: '☀️' },
  { key: 'fall',   label: 'Fall',   emoji: '🍂' },
  { key: 'winter', label: 'Winter', emoji: '❄️' },
];

export default function SeasonalPhotoStrip({
  photos = [],
  onSlotClick,
  size = 'md',
}) {
  // Pick the most recent photo per season.
  const bySeason = {};
  for (const p of photos) {
    const s = p.season || null;
    if (!s) continue;
    if (!bySeason[s]) bySeason[s] = p;
  }

  const tileClass = size === 'sm' ? 'aspect-square' : 'aspect-[4/5]';

  return (
    <div className="grid grid-cols-4 gap-2">
      {SLOTS.map(({ key, label, emoji }) => {
        const photo = bySeason[key];
        return (
          <button
            key={key}
            onClick={() => onSlotClick?.(key, photo)}
            className={`relative rounded-xl overflow-hidden bg-garden-primaryLight border border-black/5 text-left ${tileClass}`}
          >
            {photo ? (
              <img
                src={photo.image_url}
                alt={`${label} photo`}
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
            ) : (
              <div className="absolute inset-0 flex flex-col items-center justify-center text-garden-primaryDark">
                <div className="text-2xl" aria-hidden>{emoji}</div>
                <div className="text-[10px] font-medium mt-1 text-garden-muted">
                  {label}
                </div>
              </div>
            )}
            <div className="absolute top-1 left-1 px-1.5 py-0.5 text-[10px] font-medium bg-white/90 rounded text-garden-ink">
              {label}
            </div>
          </button>
        );
      })}
    </div>
  );
}
